import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-850b385c")

_pushScopeId("data-v-850b385c")
const _hoisted_1 = /*#__PURE__*/_createVNode("span", { style: {"margin-left":"160px"} }, "对外展示名称", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 唯一不可修改 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("确定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titlename,
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.visible = $event)),
    width: "800px",
    "before-close": _ctx.onCancel
  }, {
    footer: _withId(() => [
      _createVNode("span", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.handleSubmit
        }, {
          default: _withId(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_el_form, {
        ref: "formRef",
        rules: _ctx.rules,
        model: _ctx.formData,
        "label-width": "auto"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_form_item, {
            label: "名称:",
            prop: "name"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                style: {"width":"50px"},
                modelValue: _ctx.formData.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.name = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "标识:",
            prop: "identification"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.identification,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.identification = $event)),
                disabled: _ctx.isdisable
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withId(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "Token指令:",
            prop: "requestContent"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.requestContent,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.requestContent = $event)),
                style: {"width":"500px"},
                rows: 5,
                type: "textarea"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "备注:",
            prop: "remark"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.remark,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.remark = $event)),
                style: {"width":"500px"},
                rows: 3,
                type: "textarea",
                maxlength: "64",
                "show-word-limit": ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "状态:",
            prop: "status"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: _ctx.formData.status,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.status = $event))
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withId(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "before-close"]))
})